<template>
  <div>
    <base-header class="pb-8 pt-4">
    </base-header>
    <div class="container-fluid mt--7">
      <h2>{{ $t("SMS Modülü") }}</h2>
      <b-row>
        <b-col sm="12" md="4">
          <b-card class="messages-ready">
            <b-list-group>
              <b-list-group-item v-for="(item, key) in smsMessages" :key="key" @click="addText(item.content)">{{ item.name }}</b-list-group-item>
            </b-list-group>
          </b-card>
        </b-col>
        <b-col sm="12" md="8">
          <b-card>
            <b-button size="sm" variant="success" v-b-modal.selectReceiver>+ Alıcı Seçimi - {{ receivers.length }}
              {{ $t('seçildi') }}</b-button>
            <b-form-group label="Mesaj" class="mt-3">
              <b-form-textarea placeholder="Mesajınızı yazın..." rows="5" v-model="message" />
            </b-form-group>

            <b-form-group class="text-right">
              <b-button variant="danger" @click="send">{{ $t('Gönder') }}</b-button>
            </b-form-group>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <b-modal ref="selectReceiver" id="selectReceiver" title="Alıcı Seçimi">
      <div class="d-flex align-items-center justify-content-between">
        <h6>Müşteri Listesi</h6>
        <a href="#" @click.prevent="selectAll">{{ $t('Tümünü seç') }}</a>
      </div>
      <b-form-group>
        <b-form-checkbox-group stacked id="receivers-checkbox" name="receivers" v-model="receivers" :options="clients" />
      </b-form-group>
      <template v-slot:modal-footer>
        <b-button variant="primary" @click="closeModal()">{{ $t('Kaydet') }}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    data() {
      return {
        clients: [],
        smsMessages: [],
        message: '',
        receivers: [],
      }
    },
    methods: {
      ...mapActions(['smsManagement', 'sendSMS']),
      selectAll () {
        this.receivers = this.clients.map(item => item.value)
      },
      send() {
        this.sendSMS({
          clients: this.receivers,
          message: this.message,
        }).then(response => {
          this.success(response.data.message);
        }).catch(error => {
          this.error(error.response.data.message);
        });
      },
      closeModal() {
        this.modal = {
          receiver: null,
        };
        this.$refs.selectReceiver.hide();
      },
      addText(text) {
        this.message += text;
      },
    },
    mounted() {
      this.loaded = false;
      this.smsManagement().then(data => data.data).then(response => {
        this.clients = response.clients;
        this.smsMessages = response.definitions;
        this.loaded = true;
      });
    }
  }
</script>
